/* tslint:disable */
'use client'

import Heading from '@/components/Heading/Heading'
import {useParams} from '@/utils/navigation'
import DynamicForm from '@/components/DynamicForm/index.jsx'
import React, {useEffect, useRef, useState} from 'react'

import defineSectionsForm from './modelView/defineSectionsForm'
import axios from '@/services/axios'
import useStateManagement from '@/hooks/stateManagement/useStateManagement'


// Mapping
import sectionMapping from './modelView/dataMapping/section'
import shapeProfileMapping from './modelView/dataMapping/shapeProfile'
import productProfileMapping from './modelView/dataMapping/productProfile'

import uploadGLB from './modelView/actions/uploadGLB'
import uploadSTL from './modelView/actions/uploadSTL'
import loadSTL from './modelView/actions/loadSTL'
import UploadThumbnail from './modelView/actions/uploadThumbnail'
import CreateSections from './modelView/actions/createSections'
import CreateProductProfile from './modelView/actions/createProfile'

import productProfileLoadData from './modelView/dataMapping/loadProductProfile'
import shapeProfileLoadData from './modelView/dataMapping/loadShapeProfile'
import sectionsLoadData from './modelView/dataMapping/loadSections'
import downloadFile from '@/services/downloadFile'
import {getCompanyId} from '@/utils/getCompanyId'
import convertSingleToBundle from "@/components/Products/utils/convertSingleToBundle";
import useRouter from "@/utils/Router";
import store from "@/store";

export default function Product() {


    const {sku} = useParams()
    const companyId = getCompanyId()
    const router = useRouter()


    const [loaded, setLoaded] = useState(false)
    const [product, setProduct] = useState(null)
    const myFormRef = useRef(null)

    const getFormData = async () => {
        // @ts-ignore
        const formData = await myFormRef?.current?.getData(true)
        await createProfile({product: product, formData: formData})
    }


    const getPricing=async ()=>{
    const response:any =await axios(`/pricing/`, 'GET')
     const  pricingList=   response?.contents?.map((item:any) => ({
                label: item?.name,
                value: item?.id,
            }))

        // @ts-ignore
        myFormRef?.current?.setData({ pricingList: pricingList })
        return pricingList


}

    const getProduct = async (inSKU = null) => {
        const response: any = await axios(`/products/?sku=${inSKU || sku}`, 'GET')

        const productPricingList:any=await getPricing()

        if (response) {
            setProduct(response)

            if (response.product_profile_id && response.product_profile_id !== '') {
                const profileData = await axios(`/productProfiles/${response.product_profile_id}`, 'GET') //|| {}


                await loadData(profileData, {...response, product_profile: profileData},productPricingList)
            } else {
                await loadData(null, {...response, product_profile: null},productPricingList)
            }
            window.scrollTo(0, 0)
            setLoaded(true)
        } else {
            setLoaded(true)
        }
    }


    // @ts-ignore
    //window.getProduct = getProduct
    // @ts-ignore
    window.prfileSetForm = myFormRef


    const loadData = async (data: any, productData: any, pricingList: any) => {
        if (myFormRef.current) {
            let innerInitialData = {}
            if (data) {
				//console.log("--------- profile", data, productData)
                innerInitialData = {
                    product_profile: productProfileLoadData(data),
                    shape_profile: shapeProfileLoadData(data.shape_profile),
                    sections: sectionsLoadData(data.shape_profile.sections),
                    objectFile: await downloadFile(data.shape_profile?.['3d_model_url']),
                    objectFile_url: data.shape_profile?.['3d_model_url'],
                    stlFile: await downloadFile(data.shape_profile?.['stl_url']),
                    stlFile_url: data.shape_profile?.['stl_url'],
                    pricing: data.pricing?.['id'],
                }

            }

            let innerInitial = {
                pricingList:pricingList,
                product: productData,
                createUpdateProfile: getFormData,
                ...innerInitialData,
            }
            // @ts-ignore
            myFormRef?.current?.setData(innerInitial)
        }
    }

    useEffect(() => {
        getProduct()
    }, [sku])

    const {
        runSteps: createProfile,
        stateInProgress,
    } = useStateManagement({
        product: {
            main: async (state, form) => {
                return {
                    companyId: companyId,
                    productId: form?.formData?.product?.product_id,
                    productSKY: form?.formData?.product?.sku,
                    productName: form?.formData?.product?.name,
                    variantName: form?.formData?.product?.variant_name,
                    profileId: form?.formData?.product?.product_profile_id,
                    shapeId: form?.formData?.product?.product_profile?.shape_profile?.id,
                    pricing: form?.formData?.product?.pricing?.id,
                }
            },
            startMessage: () => 'Get Product ...',
            errorMessage: () => 'Get Product failed :(',
        },
        uploadGlb: {
            main: async (state, form) => {
                if (form.formData?.objectFile_url) {
                    return form?.formData?.objectFile_url
                } else {
                    return await uploadGLB(form?.formData?.objectFile, state)
                }
            },
            startMessage: () => 'Uploading GLB file...',
            errorMessage: () => 'GLB file upload failed :(',
        },

        uploadSTL: {
            main: async (state, form) => {
                if (form.formData?.stlFile_url) {
                    return form?.formData?.stlFile_url
                } else if (form?.formData?.stlFile) {
                    return await uploadSTL(form?.formData?.stlFile, state)
                } else {
                    return null
                }
            },
            startMessage: () => 'Uploading STL file...',
            errorMessage: () => 'STL file upload failed :(',
        },
        loadSTL: {
            main: async (state, form) => {
                if (form.formData?.stlFile_url) {
                    return form?.formData?.product?.product_profile?.shape_profile?.profile_points
                } else {
                    return await loadSTL(state?.uploadSTL)
                }
            },
            startMessage: () => 'Loading STL file...',
            errorMessage: () => 'Load STL file failed :(',
        },

        uploadThumbnail: {
            main: async (state, form, notif) => {
                const totalSections = form?.formData?.thumbnail_image_url?.length

                const thumbList = []
                for (let index = 0; index < totalSections; index++) {
                    const imageData = form?.formData?.thumbnail_image_url[index]
                    notif(`Uploading thumbnail ${index + 1}/${totalSections}`)

                    const thumb = imageData ? await UploadThumbnail(imageData, state, index) : ''
                    thumbList.push(thumb)
                    if (index === totalSections - 1) {
                        return thumbList
                    }
                }

                return null
            },
            startMessage: () => 'Uploading thumbnails...',
            errorMessage: () => 'Upload thumbnails failed :(',
        },

        assignPricing: {
            main: async (state, form) => {
                return form?.formData?.pricing

            },
            startMessage: () => 'Updating pricing...',
            errorMessage: () => 'Updating pricing failed :(',
        },


        createSections: {
            main: async (state, form, notif) => {
                const mappedSections = sectionMapping(form?.formData?.sections)
                const totalSections = mappedSections.length
                const sectionList = []

                for (let index = 0; index < totalSections; index++) {
                    const section = mappedSections[index]
                    notif(`Create section ${index + 1}/${totalSections}`)
                    const sectionId = await CreateSections(section, state?.uploadThumbnail[index])
                    sectionList.push(sectionId)
                    if (index === totalSections - 1) {
                        return sectionList
                    }
                }

                return null
            },
            startMessage: () => 'Creating sections...',
            errorMessage: () => 'Create sections failed :(',
        },
        createShapeProfile: {
            main: async (state, form) => {
                return await shapeProfileMapping(form?.formData?.shape_profile, state)
            },
            startMessage: () => 'Creating Shape Profile...',
            errorMessage: () => 'Create Profile failed :(',
        },
        createProductProfile: {
            main: async (state, form) => {


                console.log("form?.formData?.product_profile-------->", form, state)
                let productProfile = await productProfileMapping(form?.formData, state)
                let update = false
                if (state.product?.profileId) update = true


                const product_profile_response = await CreateProductProfile(productProfile, update)
                console.log("product_profile_id--->", productProfile, state, form, product_profile_response)

                getProduct()
                // @ts-ignore
                /*const mappedProduct = {
                    product: {
                        ...form?.formData?.product,
                        product_profile_id: product_profile_response.product_profile_id,
                    },
                    createUpdateProfile: getFormData,
                }

                mappedProduct.product.product_profile.shape_profile.id = product_profile_response.shape_profile_id

                console.log("mapped", mappedProduct)
                // @ts-ignore
                myFormRef?.current?.setData(mappedProduct)*/
                return product_profile_response


            },
            startMessage: () => 'Creating Product Profile...',
            successMessage: () => 'Product Profile Created :)',
            errorMessage: () => 'Create Profile failed :(',
        },
    })

    const bundle = new URLSearchParams(window.location.search).get('bundle');

    return (
        <div className="flex h-full w-full bg-white gap-[32px]">
            <div className="flex-grow w-full">
                <Heading
                    title={
                        <div className={"flex flex-row gap-md items-center justify-center"}>
                            {product?.['name'] || '...'}
                            <span className="font-icon-light text-gray-300 select-none"></span>
                            <span className={'inline-flex gap-xs text-gray-300 !text-text-lg select-none'}>Single</span>
                        </div>
                    }
                    description={product?.['variant_name']}
                    parent={{
                        title: `${bundle ? "Main Product" : "Products"}`,
                        url: `/products${bundle ? `/bundle/${bundle}` : ''}`,
                    }}
                    options={[
                        {
                            title: 'Convert to Bundle',
                            onClick: async () => {
                                if (product) {
                                    store.loadingPage = "Converting to bundle, please wait...";
                                    const response = await convertSingleToBundle(product);
                                    if (response) {
                                        router.push(`/products/bundle/${product?.["sku"]}`);
                                    }
                                    store.loadingPage = null;
                                }
                            },
                            icon: '',
                            disabled: !product
                        },
                        {
                            title: 'Download Profile',
                            icon: '',
                            disabled: true

                        },
                    ]}
                >
                    {product && (
                        <div className={'flex flex-row gap-xxl items-center'}>
                            <div>
                                <img src={product?.['2d_image_url']} alt="" width={100} height={100}/>
                            </div>
                            <div className="flex-col justify-start items-start gap-2 inline-flex">
                                <div className="text-neutral-600 text-sm font-normal flex flex-row">
                                    <span className={'text-gray-400 w-[60px]'}>Sku: </span>
                                    {product?.['sku']}
                                </div>
                                <div className="text-neutral-600 text-sm font-normal capitalize flex flex-row">
                                    <span className={'text-gray-400 w-[60px]'}>Variant: </span>
                                    {product?.['variant_name'] || <span className={'text-gray-400'}>-</span>}
                                </div>
                                <div className="text-neutral-600 text-sm font-normal flex flex-row">
                                    <span
                                        className={'text-gray-400 w-[60px]'}>Price: </span>${Number(product?.['price']).toFixed(2)}
                                </div>
                            </div>
                        </div>
                    )}
                </Heading>

                <div className={'px-xxl gap-lg flex flex-row x-[100%] pb-[200px]'}>
                    <div className={'w-[37px]'}/>
                    <div className={`w-[calc(100%-61px)]`}>
                        <div className={`flex flex-col gap-xl relative ${!loaded ? 'hidden' : ''}`}>
                            <DynamicForm
                                // @ts-ignore
                                items={defineSectionsForm}
                                size={'md'}
                                ref={myFormRef}
                            />
                        </div>
                        <div
                            className={`flex justify-center items-center p-xl text-gray-400 ${loaded ? 'hidden' : ''}`}>
                            loading...
                        </div>
                    </div>
                </div>
                {stateInProgress && (
                    <div
                        className={
                            'fixed top-0 left-0 w-full h-full bg-gray-600 bg-opacity-50 flex justify-center items-center z-[100]'
                        }
                    ></div>
                )}
            </div>
        </div>
    )
}
